import {FC} from "react";

export const IconApple: FC<IconProps> = ({size = 16}) => <svg
    className="fill-black"
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={size}
    height={size}
    viewBox="0 0 24 24"
>
  <g id="White-Logo-Square-">
    <path
        id="_xF8FF_"
        className="st0"
        d="M12.3,5.8c1,0,2.3-0.7,3-1.6c0.7-0.8,1.2-2,1.2-3.2c0-0.2,0-0.3,0-0.5c-1.1,0-2.5,0.8-3.3,1.8
		c-0.6,0.7-1.2,1.9-1.2,3.1c0,0.2,0,0.4,0,0.4C12,5.8,12.2,5.8,12.3,5.8z M8.7,23.5c1.4,0,2-1,3.7-1c1.7,0,2.1,0.9,3.7,0.9
		c1.5,0,2.5-1.4,3.5-2.8c1.1-1.6,1.5-3.2,1.5-3.3c-0.1,0-3-1.2-3-4.6c0-3,2.3-4.3,2.4-4.4c-1.5-2.2-3.8-2.3-4.4-2.3
		c-1.7,0-3.1,1.1-3.9,1.1c-0.9,0-2.2-1-3.6-1c-2.8,0-5.6,2.4-5.6,6.8c0,2.8,1.1,5.7,2.3,7.6C6.4,22.2,7.3,23.5,8.7,23.5z"
    />
  </g>
</svg>

export type IconProps = {
  size?: number;
}

export const IconGoogle: FC<IconProps> = ({size = 16}) => {
  return <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 48 48"
  >
    <g>
      <path
          fill="#EA4335"
          d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
      />
      <path
          fill="#4285F4"
          d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
      />
      <path
          fill="#FBBC05"
          d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
      />
      <path
          fill="#34A853"
          d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
      />
      <path fill="none" d="M0 0h48v48H0z"></path>
    </g>
  </svg>;
}

export const IconMicrosoft: FC<IconProps> = ({size = 16}) => <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={size}
    height={size}
    viewBox="0 0 129 129"
>
  {" "}
  <path className="fill-[#F25022]" d="M0,0h61.3v61.3H0V0z"/>
  <path className="fill-[#7FBA00]" d="M67.7,0H129v61.3H67.7V0z"/>
  <path className="fill-[#00A4EF]" d="M0,67.7h61.3V129H0V67.7z"/>
  <path
      className="fill-[#FFB900]"
      d="M67.7,67.7H129V129H67.7V67.7z"
  />
</svg>

export const IconFacebook: FC<IconProps> = ({size = 16}) => <svg
    data-name="Layer 1"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 58 58"
>
  <path
      className="fill-[#4267B2]"
      d="M53.85,0H3.15A3.15,3.15,0,0,0,0,3.15v50.7A3.15,3.15,0,0,0,3.15,57h27.3V35H23V26.33h7.41V20c0-7.37,4.49-11.38,11.06-11.38A62.15,62.15,0,0,1,48.15,9v7.69H43.61c-3.57,0-4.26,1.69-4.26,4.18v5.5H47.9L46.79,35H39.35V57h14.5A3.15,3.15,0,0,0,57,53.85V3.15A3.15,3.15,0,0,0,53.85,0Z"
  />
</svg>

export const IconClever: FC<IconProps> = ({size = 16}) => <svg
    data-name="Layer 1"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="1 0 58 65">
  <path className="fill-[#2A4ED2]"
        d="m 48.339983,43.48962 c -3.095298,2.11646 -5.581835,4.620294 -9.267363,5.761211 -9.327496,2.887092 -18.144075,-2.579417 -20.8576,-11.733512 -3.509201,-11.838335 5.988755,-24.491808 18.592245,-22.357987 2.867117,0.485404 5.456006,1.852587 7.825774,3.482881 0.779694,0.536458 2.290686,2.336654 3.276528,2.210062 0.775163,-0.09951 1.494928,-1.325214 1.958708,-1.869682 1.294342,-1.518982 2.616074,-3.014282 3.912886,-4.53071 0.484169,-0.56636 1.369306,-1.291397 1.50811,-2.059414 C 55.592417,10.715364 51.212043,8.2716019 49.987515,7.5431459 43.751404,3.8332559 35.893298,2.7500646 28.77555,3.864491 22.872653,4.788721 17.134671,7.4842467 12.926177,11.777672 1.5575942,23.37553 2.0259451,43.81995 14.359652,54.550939 c 2.577852,2.242701 5.626793,4.016062 8.855481,5.137208 8.419503,2.923337 18.517015,2.276065 26.154559,-2.487978 1.786335,-1.11435 3.3692,-2.494156 4.942593,-3.884056 0.520002,-0.459456 1.551974,-1.201668 1.45786,-2.000719 -0.101736,-0.862483 -1.298667,-1.694282 -1.869744,-2.265356 z"></path>
</svg>

export const IconClasslink: FC<IconProps> = ({size = 16}) => <svg
    data-name="Layer 1"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="none"
    viewBox="0 0 129 95">
  <path d="M97.2 48.4C97.2 64.1 82.2 76.8 63.6 76.8C45 76.8 30 64.1 30 48.4C30 32.7 45 20 63.6 20C82.2 20 97.2 32.7 97.2 48.4Z"
        fill="#008AD7"/>
  <rect width="129" height="95" fill="url(#pattern0)"/>
  <g filter="url(#filter0_d)">
    <path fillRule="evenodd" clipRule="evenodd"
          d="M94.1 6.9C109.7 18.5 102.9 35.5 102.9 35.5C102.9 35.5 121.9 41.1 122.3 61.9C122.7 82.7 98.9 84.7 98.9 84.7L30.3 85C30.3 85 7 82.4 6 62.8C5 41.6 24.9 35.8 24.9 35.8C24 31.3 22.2 22.4 32.8 15.7C45.1 8 55.1 18 55.1 18C69.1 -9.6 94.1 6.9 94.1 6.9ZM42.1 63.5C42.1 63.5 46.8 73.4 60 73.6C60 73.6 74.9 74.9 88.7 58.3L86.4 57.9C85.7 58.9 84.9 59.8 84 60.7C80.6 59.1 77.5 57 74.8 54.4C77 52.9 79 51.3 80.8 49.4C80.8 49.4 97 33.4 79.4 29.6L75.9 33.7C75.9 33.7 87.4 31.9 79.1 43.6C77.2 46.1 74.9 48.2 72.4 50.1C71.6 47 71.9 42.4 76.6 36.3L74.3 36.4C69.6 42.9 65.3 46.1 60.7 46.9C58.1 47.4 55.3 47.4 52.7 46.9L52 47.9C59.6 49.1 61.5 51.2 61.5 51.2C61.5 51.2 63 52 63.1 55.4C58.9 57.2 54.6 58.5 50.1 59.1C50.1 59.1 49 59.3 47.5 59.4C46.8 57.2 46.6 55 46.7 52.7C46.7 52.7 47.7 35.5 68.2 27.2L59.2 25.8C55.5 27.8 52.2 30.4 49.3 33.5C45.4 37.5 42.4 42.3 40.8 47.7C40.9 47.3 41 46.9 41.1 46.6C41.1 46.6 36.8 50.4 36.3 54.2C35.8 58.1 38 60.5 41.6 61.9C41.5 62.4 41.8 62.9 42.1 63.5ZM62.6 44C64.7 44 66.3 42.3 66.2 40.2C66.1 38.1 64.5 36.5 62.4 36.6C60.4 36.6 58.8 38.2 58.8 40.1C58.7 42.2 60.3 43.9 62.4 44C62.5 44 62.6 44 62.6 44ZM40.1 50L40 50.5C35.5 55.7 40 58.1 40 58.1C40.2 58.2 40.3 58.3 40.5 58.3C39.8 55.6 39.7 52.8 40.1 50ZM67.3 58C63.8 60.4 59.6 68.4 59.6 68.4H57.5C58.7 65.9 59.6 63.4 60.3 60.7L59.4 61C55.4 62.4 51.2 63.2 47 63.3C51 69.3 58.4 70.4 58.4 70.4C68.8 71.8 76.6 66.1 80.8 62C72.1 57.3 67.3 58 67.3 58Z"
          fill="white"/>
  </g>
  <defs>
    <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
      <use xlinkHref="#image0"/>
    </pattern>
    <filter id="filter0_d" x="1.96353" y="0.00709534" width="124.341" height="90.9929" filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB">
      <feFlood floodOpacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
      <feOffset dy="2"/>
      <feGaussianBlur stdDeviation="2"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
    </filter>
    <image id="image0"
           xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIEAAABfCAYAAADPlKQPAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"/>
  </defs>
</svg>
